/**
 * 收货单位接口
 * Created by stonewang on 2017/8/29.
 */
import {config, request} from 'Utils';

/*购货单位列表接口*/
export function list(param) {
    return request(`${config.server}/api/v1/dms/dmsPurchase/list`, {
        method: 'post',
        body: param,
    });
}

/*购货单位详情接口*/
export function detail(param) {
    return request(`${config.server}/api/v1/dms/dmsPurchase/detail/${param}`);
}

/*终端单位-地址信息接口*/
export function getAddressList(param) {
    return request(`${config.server}/api/v1/dms/dmsPurchase/address/${param}`);
}

/*信用情况接口*/
export function getCreditList(param) {
    return request(`${config.server}/api/v1/dms/dmsErpCredit/gdCredit`, {
        method: 'post',
        body: param,
    });
}

export function updatePurchase(param) {
    return request(`${config.server}/api/v1/dms/dmsPurchase/updatePurchase`, {
        method: 'post',
        body: param,
    });
}


// WEBPACK FOOTER //
// ./src/service/purchaseUnit/index.js